import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTheme } from "@emotion/react";
import { DesktopDatePickerField, FormTextField, PasswordField } from "../../../generic/GenericTextFields";
import { AlreadyHaveAccount } from "../generic/GenericDialogFooter";
import { GenericCheckBox } from "../../../generic/GenericCheckBox";
import LoadingButton from "@mui/lab/LoadingButton";

export const SignUpForm = ({ formik, handleOpenLoginDialog, isLoading }) => {
  const [isAgree, setIsAgree] = useState(false);
  const theme = useTheme();

  return (
    <Stack gap={4}>
      <FormTextField
        value={formik.values.email}
        placeholder={'example@email.com'}
        label={'Email'}
        error={Boolean(formik?.errors?.email)}
        helperText={formik?.errors?.email}
        handleChange={(value) => formik.setFieldValue('email', value)}
      />
      <PasswordField
        value={formik.values.password}
        placeholder={'************'}
        label={'Password'}
        error={Boolean(formik?.errors?.password)}
        helperText={formik?.errors?.password}
        handleChange={(value) => formik.setFieldValue('password', value)}
      />
      <PasswordField
        value={formik.values.password_confirmation}
        placeholder={'************'}
        label={'Confirm Password'}
        error={Boolean(formik?.errors?.password_confirmation)}
        helperText={formik?.errors?.password_confirmation}
        handleChange={(value) => formik.setFieldValue('password_confirmation', value)}
      />
      <DesktopDatePickerField
        value={formik?.values?.birthday}
        label={'Birthday'}
        error={Boolean(formik?.errors?.birthday)}
        helperText={formik?.errors?.birthday}
        handleChange={(value) => formik.setFieldValue('birthday', value)}
      />
      <Stack direction={'row'} alignItems={'center'} justifyContent={'center'}>
        <GenericCheckBox
          checked={isAgree}
          iconSize={20}
          onChange={(event) => setIsAgree(event.target.checked)}
        />
        <Typography variant="body2">
          I agree to the <a href="/terms-and-conditions" target="_blank" style={{ textDecoration: 'none', color: theme.palette.primary.main }}>Terms of Service</a> and <a href="/privacy-policy" target="_blank" style={{ textDecoration: 'none', color: theme.palette.primary.main }}>Privacy Policy</a>
        </Typography>
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <LoadingButton
          onClick={() => formik.handleSubmit()}
          loading={isLoading}
          variant="contained"
          disabled={isLoading || !isAgree}
          sx={{ color: '#FFF', width: { xs: '100%', sm: '250px' } }}
        >
          Sign Up
        </LoadingButton>
      </Box>
      <AlreadyHaveAccount handleOpenLoginDialog={handleOpenLoginDialog} />
    </Stack>
  );
};